import {
  ACT_TAGS_FETCH_INIT,
  ACT_TAGS_FETCH_200,
} from '../constants/actions';

const defaultState = {
  tagsList: [],
  isLoadingTags: false,
  didLoadTags: false,
};

const tagsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_TAGS_FETCH_INIT:
      return {
        ...state,
        tagsList: [],
        isLoadingTags: true,
        didLoadTags: false,
      };
    case ACT_TAGS_FETCH_200:
      return {
        ...state,
        tagsList: action.payload,
        isLoadingTags: false,
        didLoadTags: true,
      };
    default:
      return state;
  }
};

export default tagsReducer;
